module.exports = __webpack_public_path__ + "img/20220805140813.f7231181.jpg";